import React from 'react'

const UnAuthGuard = ({component}) => {
    return <React.Fragment>{component}</React.Fragment>
}

export default UnAuthGuard